const formulaRouter = [
    {
        path: "formula",
        name: "formula",
        component: () => import("@/views/admin/formula/function"),
        default: true,
        meta: {
            model: "formula"
        },
    }
]
export default formulaRouter;